import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getSiteWorkData = job => {
    let drawingsList = []
    job.drawings.forEach(item => {
      drawingsList.push(
        <div>
          {job.drawings.length > 1 && <h6 className="marginTop20">{item.name}</h6>}
          <div className="row" key={item.id}>
            {item.requested_preliminary_layout_drawings_date &&
              this.checkedDateListContains('Requested Preliminary Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Requested Preliminary Layout Drawings
                  </p>
                  <p>
                    {moment(item.requested_preliminary_layout_drawings_date).format('YYYY-M-D')}
                  </p>
                </div>
              )}
            {item.received_preliminary_layout_drawings_date &&
              this.checkedDateListContains('Received Preliminary Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Received Preliminary Layout Drawings
                  </p>
                  <p>{moment(item.received_preliminary_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.sent_preliminary_layout_drawings_date &&
              this.checkedDateListContains('Sent Preliminary Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Sent Preliminary Layout Drawings</p>
                  <p>{moment(item.sent_preliminary_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.requested_final_layout_drawings_date &&
              this.checkedDateListContains('Requested Final Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Requested Final Layout Drawings</p>
                  <p>{moment(item.requested_final_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.received_final_layout_drawings_date &&
              this.checkedDateListContains('Received Final Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Received Final Layout Drawings</p>
                  <p>{moment(item.received_final_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.sent_final_layout_drawings_date &&
              this.checkedDateListContains('Sent Final Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Sent Final Layout Drawings</p>
                  <p>{moment(item.sent_final_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.final_approved_layout_drawings_date &&
              this.checkedDateListContains('Final Approved Layout Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Final Approved Layout Drawings</p>
                  <p>{moment(item.final_approved_layout_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.requested_preliminary_design_drawings_date &&
              this.checkedDateListContains('Requested Preliminary Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Requested Preliminary Design Drawings
                  </p>
                  <p>
                    {moment(item.requested_preliminary_design_drawings_date).format('YYYY-M-D')}
                  </p>
                </div>
              )}
            {item.received_preliminary_design_drawings_date &&
              this.checkedDateListContains('Received Preliminary Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Received Preliminary Design Drawings
                  </p>
                  <p>{moment(item.received_preliminary_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.sent_preliminary_design_drawings_date &&
              this.checkedDateListContains('Sent Preliminary Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Sent Preliminary Design Drawings</p>
                  <p>{moment(item.sent_preliminary_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.requested_final_design_drawings_date &&
              this.checkedDateListContains('Requested Final Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Requested Final Design Drawings</p>
                  <p>{moment(item.requested_final_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.received_final_design_drawings_date &&
              this.checkedDateListContains('Received Final Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Received Final Design Drawings</p>
                  <p>{moment(item.received_final_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.sent_final_design_drawings_date &&
              this.checkedDateListContains('Sent Final Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Sent Final Design Drawings</p>
                  <p>{moment(item.sent_final_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.final_approved_design_drawings_date &&
              this.checkedDateListContains('Final Approved Design Drawings') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Final Approved Design Drawings</p>
                  <p>{moment(item.final_approved_design_drawings_date).format('YYYY-M-D')}</p>
                </div>
              )}
          </div>
        </div>
      )
    })
    return drawingsList
  }

  checkedDateListContains = text => {
    const { checkedDateList } = this.props
    if (checkedDateList.length == 0) {
      return true
    }
    return checkedDateList.indexOf(text) >= 0
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      if (item.drawings && item.drawings.length > 0) {
        jobList.push(
          <div>
            <h5 className="steps">{item.job_name}</h5>
            {this.getSiteWorkData(item)}
          </div>
        )
      }
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Drawing Schedules</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/drawing-schedules/ListItem.js